<template>
  <v-row justify="center">
    <!-- หน้าจอปกติ -->
    <v-dialog v-model="shower" scrollable persistent max-width="600px" v-if="resolutionScreen >= 500">
        <v-card>
            <v-card-title>{{$t('admin.confirm_delete_employee')}}<v-spacer></v-spacer>
          <v-icon :color="color.theme" dark size="35">mdi-account-minus</v-icon>
          </v-card-title>
            <v-divider></v-divider>
            <v-card-subtitle>
            <v-card-text>
              <v-card-text style="text-align: center;">
                <span style="font-size:18px;">{{$t('admin.confirm_delete_text')}}</span><br/>
                <span v-if="$t('default') === 'th'" style="color:#C11304;font-size:18px;">{{'[' + $t('user_account') + ' ' + ' ' + data_user.user_name_th + ' ' + ']'}}</span> 
                <span v-else style="color:#C11304;font-size:18px;">{{'[' + $t('user_account') + ' ' + ' ' + data_user.user_name_en + ' ' + ']'}}</span> 
                 <!-- <span v-if="$t('default') === 'th'" style="color:#C11304;font-size:18px;">{{'['+ ' ' + data_user.account_title_th + ' ' +data_user.user_name_th + ' ' + data_user.last_name_th + ' ' + ']'}}</span> -->
                 <!-- <span v-else style="color:#C11304;font-size:18px;">{{'['+ ' ' +data_user.account_title_eng + ' ' +data_user.first_name_eng + ' ' + data_user.last_name_eng + ' ' + ']'}}</span> -->
              </v-card-text>
              </v-card-text>
              </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="$emit('close')">{{$t('admin.close')}}</v-btn>
           <v-btn  :color="color.theme" :dark="color.darkTheme" @click="delete_user()">{{$t('admin.delete_employee')}}</v-btn>        
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- หน้าจอมือถือ -->
    <v-dialog
    v-model="shower"
    scrollable
    persistent
    :max-width="maxWidthOnMobile"
    content-class="rounded-lg"
    v-else
  >
    <v-card>
      <v-card-text class="pa-5">
        <v-layout class="pt-2 pb-4">
          <v-flex d-flex justify-center class="ml-6">
            <span :style="headerPage">{{
              $t("admin.confirm_delete_employee")
            }}</span>
          </v-flex>
          <v-flex xs1 d-flex justify-end>
            <v-icon
              :color="$vuetify.theme.dark ? 'white' : color.theme"
              @click="$emit('close')"
              >mdi-close</v-icon
            >
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-subtitle>
            <v-card-text>
              <v-card-text class="px-2 pt-1 pb-1 text-center" :style="titleText">
                <span style="font-size:15px;">{{$t('admin.confirm_delete_text')}}</span><br/>
                 <!-- <span v-if="$t('default') === 'th'" style="color:#C11304;font-size:15px;">{{'['+ ' ' +data_user.account_title_th + ' ' +data_user.first_name_th + ' ' + data_user.last_name_th + ' ' + ']'}}</span>
                 <span v-else style="color:#C11304;font-size:15px;">{{'['+ ' ' +data_user.account_title_eng + ' ' +data_user.first_name_eng + ' ' + data_user.last_name_eng + ' ' + ']'}}</span> -->
                 <span v-if="$t('default') === 'th'" style="color:#C11304;font-size:18px;">{{'[' + $t('user_account') + ' ' + ' ' + data_user.user_name_th + ' ' + ']'}}</span> 
                 <span v-else style="color:#C11304;font-size:18px;">{{'[' + $t('user_account') + ' ' + ' ' + data_user.user_name_en + ' ' + ']'}}</span> 
              </v-card-text>
              </v-card-text>
              </v-card-subtitle>
      <div class="text-center my-4">
        <v-btn
          :style="btnAction"
          class="mr-6"
          height="40px"
          width="40%"
          color="red"
          outlined
          @click="$emit('close')"
          >{{ $t("admin.close") }}</v-btn
        >
        <v-btn
          height="40px"
          width="40%"
          class="elevation-0"
          :style="btnAction"
          :color="color.theme"
          dark
           @click="delete_user()"
          >{{ $t("admin.delete_employee") }}</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
  </v-row>  
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import VueCookies from "vue-cookies";
import CryptoJS from "crypto-js";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
    props: ["show", "data_user"],
    data: function() {
      return {
        
      }
    },
    computed: {
      ...mapState(["username", "authorize", "account_active", "service", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
      "dataStorageUsage",
      "dataStorageMax",
    ]),
    shower :{
            get() {
                if(this.show === true){

                }
                return this.show
            },
            set (value) {
                if (!value) {
                 this.selected=[];
                }
            }
    },
    colorProgress(){
      return 'color:'+this.color.theme+';'
    },
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    // style อักษร header ของ mobile
    headerPage() {
      return (
        "color:" +
        this.color.theme +
        ";" +
        "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
      );
    },
    // style ปุ่ม ของ mobile
    btnAction() {
      return "font-size: 16px; font-weight: lighter;";
    },
    // style อักษรใน dialog ของ mobile
    titleText() {
      return "color:black; font-size: 14px; line-height: 28px;";
    },
    // ความกว้างของ dialog ของ ipad และ mobile
    maxWidthOnMobile() {
      if(this.resolutionScreen >= 400) {
        return 600
      } else {
        return 346
      }
    },
    },
    methods:{
     async delete_user(){

      // let accountid_info = CryptoJS.AES.decrypt(VueCookies.get("account_id"), CryptoJS.enc.Utf8.parse(process.env.VUE_APP_SECRET_KEY), { mode: CryptoJS.mode.ECB, });
      // accountid_info = window.atob(accountid_info.toString(CryptoJS.enc.Utf8))
      // console.log("accountid_info",accountid_info);
      
      // console.log(this.dataAccountActive);
      
      // console.log("delete_user",this.data_user);
      
      var payload = {
         account_admin:this.dataAccountId,
         business_id: this.dataAccountActive.business_info.business_id,
         account_id: this.data_user.account_id,

      };
      console.log("delete_user_payload",payload);
     let auth = await gbfGenerate.generateToken();
     await this.axios
        .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/admin/delete_user_in_business", payload,{
            headers: { Authorization: auth.code },})
        .then((response) => {
          if (response.data.status === "OK") {
            // console.log("ok", response);
            Toast.fire({
              icon: "success",
              title: this.$t("admin.success_delete_employee"),
            });
            this.$emit('close');
          }else {
            // console.log("error", response);
            Toast.fire({
              icon: "error",
              title: this.$t("error_delete_em") ,
              // title: response.data.errorCode + " " + response.data.errorMessage,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fire({
            icon: "error",
            title: this.$t("toast.cannotconnectonebox"),
          });
        });
    },
  },
  
}
</script>
<style>

</style>